export default "__VITE_ASSET__C5Csb7_7__"